import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { MultiFactorAuthPageRoutingModule } from './multi-factor-auth-routing.module';

import { MultiFactorAuthPage } from './multi-factor-auth.page';
import { SharedModule } from '../shared/shared.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
// import moment from 'moment-timezone';
// import { Moment } from 'moment'; 


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    MultiFactorAuthPageRoutingModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatMomentDateModule,
    // Moment
  ],
  declarations: [MultiFactorAuthPage]
})
export class MultiFactorAuthPageModule {}
